// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcg_a bhm_wl","LoadingPlaceholder":"bcg_b bhm_h","loading-placeholder":"bcg_c"};